import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "status",
  "aria-live": "polite",
  "data-testid": "new-version-status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_q_banner, {
          key: 0,
          dense: "",
          class: "bg-amber-8 text-black",
          "data-testid": "new-version-banner"
        }, {
          action: _withCtx(() => [
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              "no-caps": "",
              label: "Refresh",
              "data-testid": "new-version-refresh",
              onClick: _ctx.refresh
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              "no-caps": "",
              label: "Dismiss",
              "data-testid": "new-version-dismiss",
              onClick: _ctx.dismiss
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" A new version is available. ", -1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}